const authMethods = {
  password: { id: 'password', name: 'Password' },
  saml: { id: 'saml', name: 'SAML' },
  microsoft: { id: 'microsoft', name: 'Microsoft 365' },
};

export default authMethods;
